import type { RouteDefinition } from "./route-definition.ts";

export const gameDocumentRoutes = {
  "game.playMarkdown": {
    path: "/:gameSlug/:league?/play.md",
    scope: "game",
    bucket: "catalog",
    entry: "workflow",
    disposition: "document",
  },
  "game.startProgress": {
    path: "/:gameSlug/:league?/start/progress",
    scope: "game",
    bucket: "catalog",
    entry: "workflow",
    disposition: "document",
  },
  "game.previewImage": {
    path: "/:gameSlug/:league?/preview/opengraph-image",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "document",
  },
  "game.startOverMarkdown": {
    path: "/:gameSlug/:league?/start-over.md",
    scope: "game",
    bucket: "catalog",
    entry: "workflow",
    disposition: "document",
  },
  "game.onboardingMarkdown": {
    path: "/:gameSlug/:league?/onboarding.md",
    scope: "game",
    bucket: "catalog",
    entry: "workflow",
    disposition: "document",
  },
  "game.forumMarkdown": {
    path: "/:gameSlug/forum.md",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "document",
  },
  "game.wikiMarkdown": {
    path: "/:gameSlug/wiki.md",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "document",
  },
  "game.wikiPageMarkdown": {
    path: "/:gameSlug/wiki/*page.md",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "document",
  },
  "game.opengraphImage": {
    path: "/:gameSlug/:league?/opengraph-image",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "document",
  },
  "game.twitterImage": {
    path: "/:gameSlug/:league?/twitter-image",
    scope: "game",
    bucket: "catalog",
    entry: "parent",
    disposition: "document",
  },
  "game.sitemapPage": {
    path: "/:gameSlug/sitemap-:page.xml",
    scope: "game",
    bucket: "catalog",
    entry: "direct",
    disposition: "document",
  },
} as const satisfies Record<string, RouteDefinition>;
